(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee-slider"] && !Shopify.designMode) return;
  try {
    
// Function to duplicate spans inside a marquee container
function duplicateMarqueeSpans(parentClass, numDuplicates) {
  // Select the parent container
  const parentContainer = document.querySelector(`.${parentClass}`);
  
  if (parentContainer) {
    // Get the original spans
    const originalSpans = parentContainer.querySelectorAll('span');
    const spanArray = Array.from(originalSpans); // Convert NodeList to Array for cloning

    // Loop to create duplicates
    for (let i = 0; i < numDuplicates; i++) {
      spanArray.forEach((span) => {
        const clonedSpan = span.cloneNode(true); // Clone the original span
        parentContainer.appendChild(clonedSpan); // Append the cloned span to the parent
      });
    }
  }
}

// Duplicate spans for each marquee container
duplicateMarqueeSpans('marquee_first_slide_main', 10); // First marquee
duplicateMarqueeSpans('marquee_sec_slide_main', 10);   // Second marquee


  } catch(e) { console.error(e); }
})();
})();
